var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEurasiangaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19656 5.69157H10.7764V5.69288C12.1306 5.69288 12.1265 4.92635 12.1237 4.41246C12.1236 4.38974 12.1234 4.36752 12.1234 4.34588C12.1234 4.34588 12.222 3.17366 10.8198 3.17366H4.87066C3.53888 3.17366 3.55495 4.32672 3.56533 5.07161C3.5662 5.13379 3.56702 5.19312 3.56702 5.2487V8.43814C3.56702 9.40798 3.88636 10.1846 5.19656 10.1846H9.77899V13.4017H4.78787C2.45788 13.4017 0.614136 11.4318 0.614136 9.22794V3.94507C0.614136 1.97648 2.54067 0 4.56577 0H10.804C12.3298 0 15.1854 1.08811 15.1867 4.47204C15.1867 4.96879 15.1249 5.41166 15.0185 5.81116H14.4087C13.1182 5.81116 10.875 6.59045 10.2153 8.881H5.19656V5.69157ZM15.1959 6.59965H21.4355L21.4342 6.59833C23.4593 6.59833 25.3858 8.57481 25.3858 10.5434V15.8263C25.3858 18.0314 23.5407 20 21.2121 20H16.2209V16.783H20.8034C22.1136 16.783 22.4329 16.0076 22.4329 15.0365V11.847C22.4329 11.7918 22.4337 11.7329 22.4346 11.6712C22.4448 10.9264 22.4606 9.772 21.1293 9.772H15.1801C13.7779 9.772 13.8765 10.9442 13.8765 10.9442C13.8765 10.9659 13.8764 10.9881 13.8763 11.0108C13.8735 11.5247 13.8693 12.2912 15.2235 12.2912H20.8047V15.4806H15.2235C13.5874 15.4806 10.8145 14.4556 10.8145 11.0717C10.8145 7.68776 13.6702 6.59965 15.1959 6.59965Z",
    fill: "rgba(var(--provider-icon-color))"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurasiangaming);
export default __webpack_public_path__ + "static/media/eurasiangaming.1a9e082f70afc33dca0b80c702be7f8c.svg";
export { ForwardRef as ReactComponent };